import Typography from "@mui/material/Typography";
import { Association } from "../../@data/association";
import { Phone, WhatsApp } from "@mui/icons-material";
import { Button, Grow } from "@mui/material";
import * as s from "./styles";
import { justNumbersParser } from "../../utils";

interface IAssociationCard {
  association: Association;
}

export default function AssociationCard(props: IAssociationCard) {
  const { association } = props;

  return (
    <Grow in timeout={800}>
      <s.CardContainer>
        <section>
          <Typography gutterBottom variant="body1">
            {association.name}
          </Typography>
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ display: "flex", whiteSpace: "pre-line" }}
            className="description"
          >
            {association.description}
          </Typography>
          {association?.phone && (
            <Button
              variant="contained"
              startIcon={association.isWhatsApp ? <WhatsApp /> : <Phone />}
              size="small"
              sx={{ mt: "1rem" }}
              href={
                association.isWhatsApp
                  ? `https://wa.me/55${justNumbersParser(association.phone)}`
                  : `tel:${association?.phone}`
              }
            >
              {association.isWhatsApp ? "WhatsApp" : "Entrar em contato"}
            </Button>
          )}
        </section>
        {association.imageUrl && (
          <img
            src={association.imageUrl}
            alt={`Imagem da ${association.name}`}
          />
        )}
      </s.CardContainer>
    </Grow>
  );
}
